module.exports = __webpack_public_path__ + "img/teacher_code.e64b2d08.jpg";